import './App.css';
import HomePage from './Pages/Home';
import { Routes, Route } from "react-router-dom";
import { useEffect } from 'react';

import BiAnnual from './Pages/HTML/BiAnnualProgramm';
import OnlineSeminars from './Pages/HTML/OnlineSeminars';
import Workshops from './Pages/HTML/Workshops';
import Bibilo from './Pages/HTML/Bibliography';
import Prints from './Pages/HTML/PrintsPublication';
import Projects from './Pages/HTML/Projects';
import Exibit from './Pages/HTML/Exhibitions';
import VideoAccessList from './Pages/VideoAccess';

import LoginClr from './Pages/Classroom/Login';
import ClassroomHub from './Pages/Classroom/Classroomhub';
import ClassrHostLL from './Pages/Classroom/ClassroomHosting';
import JoinTheSession from './Pages/Classroom/ClassroomSession';

import DescriptionPage from './Pages/Description';
import SuccessPage from './Pages/Success';
import CancelPage from './Pages/Cancel';
import Rentals from './Pages/HTML/Rental';
import VideoGallery from './Pages/VideoGallery';

import "bootstrap/dist/css/bootstrap.min.css";

function Page({ title }) {
  return (
    <main style={{ padding: 24 }}>
      <h1 style={{ marginTop: 0 }}>{title}</h1>
      <p>Build this page as needed.</p>
    </main>
  );
}

function App() {
  useEffect(() => {
    const bubble = document.getElementById("water-bubble");
    if (!bubble) return;

    let mouseX = 0, mouseY = 0;
    let currentX = 0, currentY = 0;
    let lastX = 0, lastY = 0;

    let clickScale = 1;
    let keyScale = 1;

    const move = (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
    };

    const mouseDown = () => (clickScale = 0.85);
    const mouseUp = () => (clickScale = 1);
    const keyDown = () => (keyScale = 0.9);
    const keyUp = () => (keyScale = 1);

    document.addEventListener("mousemove", move);
    document.addEventListener("mousedown", mouseDown);
    document.addEventListener("mouseup", mouseUp);
    document.addEventListener("keydown", keyDown);
    document.addEventListener("keyup", keyUp);

    const animate = () => {
      currentX += (mouseX - currentX) * 0.15;
      currentY += (mouseY - currentY) * 0.15;

      const dx = currentX - lastX;
      const dy = currentY - lastY;
      const speed = Math.sqrt(dx * dx + dy * dy);

      const stretch = Math.min(speed / 6, 1.5);
      const angle = Math.atan2(dy, dx) * 57.2958;

      bubble.style.left = `${currentX}px`;
      bubble.style.top = `${currentY}px`;

      const finalScale = clickScale * keyScale;

      bubble.style.transform = `
        translate(-50%, -50%)
        rotate(${angle}deg)
        scale(${(1 + stretch) * finalScale}, ${(1 - stretch * 0.4) * finalScale})
      `;

      lastX = currentX;
      lastY = currentY;

      requestAnimationFrame(animate);
    };

    animate();

    return () => {
      document.removeEventListener("mousemove", move);
      document.removeEventListener("mousedown", mouseDown);
      document.removeEventListener("mouseup", mouseUp);
      document.removeEventListener("keydown", keyDown);
      document.removeEventListener("keyup", keyUp);
    };
  }, []);

  return (
    <>
      {/* Global Water Bubble */}
      <div id="water-bubble"></div>

      <Routes>
        <Route path="/" element={<HomePage />} />

        {/* ACADEMY */}
        <Route path="/online-seminars" element={<OnlineSeminars />} />
        <Route path="/shop" element={<BiAnnual />} />
        <Route path="/workshops" element={<Workshops />} />
        <Route path="/bibliography" element={<Bibilo />} />

        {/* CLASSROOM */}
        <Route path="/classroomv2/hub" element={<ClassroomHub />} />
        <Route path="/classroom" element={<LoginClr />} />
        <Route path="/classroomv2/hub/host" element={<ClassrHostLL />} />
        <Route path="/classroomv2/session/:id" element={<JoinTheSession />} />

        {/* TOP LEVEL */}
        <Route path="/projects" element={<Projects />} />
        <Route path="/publication" element={<Exibit />} />
        <Route path="/prints-publication" element={<Prints />} />
        <Route path="/descr/:id" element={<DescriptionPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/rentals" element={<Rentals />} />
        <Route path="/cancel" element={<CancelPage />} />

        {/* VIDEO GALLERY */}
        <Route path="/videoGallery" element={<VideoGallery />} />
        <Route path="/videoAccess" element={<VideoAccessList />} />

        {/* 404 */}
        <Route path="*" element={<Page title="Not Found" />} />
      </Routes>
    </>
  );
}

export default App;
